module.exports = __webpack_public_path__ + "static/media/LOGO-CONSTRUCAO.140bc665.png";